var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMapB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.202,
    height: 23.102,
    viewBox: "0 0 25.202 23.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-map",
    "data-name": "Icon feather-map",
    transform: "translate(0 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167756",
    "data-name": "Path 167756",
    d: "M24.152,1.5A1.05,1.05,0,0,1,25.2,2.55v16.8a1.05,1.05,0,0,1-.529.912l-7.35,4.2a1.05,1.05,0,0,1-.991.027l-7.9-3.949L1.571,24.463A1.05,1.05,0,0,1,0,23.551V6.75a1.05,1.05,0,0,1,.529-.912l7.35-4.2a1.05,1.05,0,0,1,.991-.027l7.9,3.949,6.863-3.921A1.049,1.049,0,0,1,24.152,1.5ZM16.8,7.8a1.049,1.049,0,0,1-.47-.111l-7.9-3.949L2.1,7.36V21.742l5.779-3.3a1.05,1.05,0,0,1,.991-.027l7.9,3.949L23.1,18.742V4.36l-5.779,3.3A1.05,1.05,0,0,1,16.8,7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167757",
    "data-name": "Path 167757",
    d: "M11.55,20.4a1.05,1.05,0,0,1-1.05-1.05V2.55a1.05,1.05,0,0,1,2.1,0v16.8A1.05,1.05,0,0,1,11.55,20.4Z",
    transform: "translate(-3.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167758",
    "data-name": "Path 167758",
    d: "M23.55,26.4a1.05,1.05,0,0,1-1.05-1.05V8.55a1.05,1.05,0,1,1,2.1,0v16.8A1.05,1.05,0,0,1,23.55,26.4Z",
    transform: "translate(-6.749 -1.8)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMapB);
export default __webpack_public_path__ + "static/media/location-map-b.51de9cd6d972bec81c63533e0f38e280.svg";
export { ForwardRef as ReactComponent };